import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';

import { ProposalRequestFile } from '../classes/models';

export function proposalRequestFileValidator(
  FormArray: AbstractControl
): ValidationErrors | null {
  const ProposalRequestFiles = FormArray.value as ProposalRequestFile[];

  let { errors } = FormArray;

  let isFileTooLarge: boolean = false;
  const totalFileSize = ProposalRequestFiles.reduce((total, prf) => {
    const { File } = prf;

    if (File) {
      const { filesize } = File;

      const fileSizeNormalized = Number(filesize) || 0;

      if (fileSizeNormalized > 10 * 1000000) {
        isFileTooLarge = true;
      }

      return fileSizeNormalized + total;
    }

    return total;
  }, 0);

  if (isFileTooLarge) {
    errors = Object.assign(errors || {}, { fileTooLarge: true });
  } else {
    if (errors) {
      delete errors['fileTooLarge'];
    }
  }

  if (totalFileSize > 25 * 1000000) {
    errors = Object.assign(errors || {}, { totalFileSize: true });
  } else {
    if (errors) {
      delete errors['totalFileSize'];
    }
  }

  if (isEmpty(errors)) {
    errors = null;
  }

  FormArray.setErrors(errors);
  return errors;
}
